export const TOKEN_KEY = "Token_AEC_PMO";

const getStoredToken = () => {
  const fromSession = sessionStorage.getItem(TOKEN_KEY);
  if (fromSession) return fromSession;
  return null;
};

export const isAuthenticated = () => getStoredToken() !== null;

export const getToken = () => getStoredToken();

export const getTokenPayload = () => {
  const token = getToken();
  if (!token) return null;

  const parts = token.split('.');
  if (parts.length < 2) return null;

  try {
    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join(''),
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    return null;
  }
};

export const getUserDisplayName = () => {
  const payload = getTokenPayload();
  
  if (!payload) return '';

  return payload.sub;
};

export const getUserRoles = () => {
  const payload = getTokenPayload();
  if (!payload) return [];

  const raw = payload.roles;
  if (!raw) return [];

  if (Array.isArray(raw)) {
    return raw
      .map((r) => (typeof r === 'string' ? r : r?.authority))
      .filter(Boolean);
  }

  if (typeof raw === 'string') {
    return raw
      .split(',')
      .map((r) => r.trim())
      .filter(Boolean);
  }

  return [];
};

export const hasAnyRole = (requiredRoles = []) => {
  if (!requiredRoles || requiredRoles.length === 0) return true;

  const userRoles = getUserRoles();
  if (!userRoles || userRoles.length === 0) return false;

  const normalizedUserRoles = userRoles.map((r) => String(r).toUpperCase());
  const normalizedRequired = requiredRoles.map((r) => String(r).toUpperCase());
  return normalizedRequired.some((r) => normalizedUserRoles.includes(r));
};

export const login = token => {
    sessionStorage.setItem(TOKEN_KEY, token);
    localStorage.removeItem(TOKEN_KEY);
};

export const logout = () => {
  sessionStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(TOKEN_KEY);
};